import { gapAnalysis } from "@/lib/proposalData";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { useDeployment } from "@/lib/DeploymentContext";

export default function GapAnalysis() {
  const d = useDeployment();
  return (
    <section
      id="gap"
      data-testid="section-gap-analysis"
      className="bg-[#EBE6D8] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-3">
              <span className="h-px w-8 bg-[#8B0000]" />
              <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#8B0000]">
                05 — What Exists. What's Missing.
              </span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0A192F] leading-tight">
              The gears are here.<br />The chain is not.
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-2">
            <p className="text-[#334155] text-base leading-relaxed">
              {d.gapAnalysisLead}
              None of them is the high-touch, multi-year, cross-agency case manager
              {" "}{d.gapAnalysisFollow}
              connecting tissue that turns scattered programs into a functioning
              system.
            </p>
          </div>
        </div>

        <div className="grid lg:grid-cols-3 gap-px bg-[#CBD5E1] border border-[#CBD5E1] mb-10">
          {gapAnalysis.map((g, i) => (
            <div
              key={g.title}
              data-testid={`gap-card-${i}`}
              className="bg-[#F9F7F1] p-7 lg:p-8 flex flex-col"
            >
              <div className="font-mono text-[10px] uppercase tracking-widest text-[#8B0000] mb-2">
                Currently Exists
              </div>
              <h3 className="font-display text-xl text-[#0A192F] leading-snug">{g.title}</h3>
              <div className="font-mono text-[10px] uppercase tracking-widest text-[#475569] mt-1 mb-5">
                {g.operator}
              </div>
              <p className="text-sm text-[#334155] mb-5 leading-relaxed">
                <CheckCircle2 className="inline h-4 w-4 text-[#0A192F] mr-1.5 -mt-0.5" />
                {g.whatItDoes}
              </p>
              <div className="mt-auto border-t border-[#CBD5E1] pt-4">
                <div className="font-mono text-[10px] uppercase tracking-widest text-[#8B0000] mb-2">
                  Why It Is Not Enough
                </div>
                <p className="text-sm text-[#0A192F] leading-relaxed">
                  <AlertTriangle className="inline h-4 w-4 text-[#8B0000] mr-1.5 -mt-0.5" />
                  {g.whyItIsNotEnough}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#0A192F] text-[#F9F7F1] p-8 lg:p-10 grid lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-2">
            <div className="font-display text-6xl text-[#D4AF37] leading-none">+</div>
          </div>
          <div className="lg:col-span-10">
            <div className="font-mono text-[10px] uppercase tracking-widest text-[#D4AF37] mb-2">
              The Big Opportunity
            </div>
            <p className="font-display text-xl lg:text-2xl leading-snug">
              {d.gapAnalysisClose}
              It is the central <em className="italic text-[#D4AF37]">air traffic controller</em> that
              accepts single mothers and seniors <em className="italic">regardless</em> of whether they
              are in public housing — and walks them through the entire ecosystem until they reach a thriving baseline.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
